import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const ErrorModal = props => {
    return (
        <Modal show={props.show} onHide={props.click}>
            <Modal.Header className="bg-brandcolor text-center" closeButton>
                <h5 className="text-white">Error</h5>
            </Modal.Header>
            <Modal.Body>
                <p>{props.msg}</p>
            </Modal.Body>
            <Modal.Footer>
               { props.showlogout?
                <Button variant="secondary"   onClick={props.logout}>
                    Logout  
                </Button> : null}
                <Button variant="secondary" onClick={props.click}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
}


export default ErrorModal;
